import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { ScreenType } from "@client/types";
import { identity } from "lodash";

export const EMPTY_ROOT_CONTAINER_PROPS: RootContainerProps = {
  id: "",
  source: "content",
  StaticContainer: identity,
  TextComponent: identity
};

export const EMPTY_MODULE_API_INFO: ModuleApiInfo = {
  baseParams: {
    context: "page",
    moduleId: "",
    pageId: "",
    pageVariantId: "",
    portalId: "",
    screenType: ScreenType.Desktop,
    path: "",
    popupId: null,
    cultureCode: null
  },
  baseUrl: "",
  i18n: {},
  url: ""
};

export const EMPTY_ROOT_CONTAINER_PROPS_WITH_API: RootContainerProps & { apiInfo: ModuleApiInfo } = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  apiInfo: EMPTY_MODULE_API_INFO
};
